module.exports = __webpack_public_path__ + "static/media/history-white.4d8609dd.svg";